var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 1.6665H5.00017C4.55814 1.6665 4.13422 1.84209 3.82166 2.15465C3.5091 2.46721 3.3335 2.89114 3.3335 3.33316V16.6665C3.3335 17.1085 3.5091 17.5324 3.82166 17.845C4.13422 18.1576 4.55814 18.3332 5.00017 18.3332H15.0002C15.4422 18.3332 15.8661 18.1576 16.1787 17.845C16.4913 17.5324 16.6668 17.1085 16.6668 16.6665V6.6665L11.6668 1.6665Z",
    stroke: "#F4F4F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 14.1665H6.6665",
    stroke: "#F4F4F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 10.8335H6.6665",
    stroke: "#F4F4F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33316 7.5H7.49983H6.6665",
    stroke: "#F4F4F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 1.6665V6.6665H16.667",
    stroke: "#F4F4F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.d1c1942e5f3ee044bbf0cd9b9a8109a6.svg";
export { ForwardRef as ReactComponent };